export const APP_ERRORS = Object.freeze({
  PLAYER_BANK_DETAILS: {
    ACCOUNT_NAME: "Acount name is required",
    ACCOUNT_NUMBER: "Please enter a valid account number",
    IFSC_CODE: "Please enter a valid IFSC Cde",
    TYPE: "Please enter a valid type",
    CARD_NO: "Please enter a valid Card Number",
    CARD_NAME: "Please enter a valid Card Name",
    EXPIRY_MONTH: "Please enter a valid Expiry Month",
    EXPIRY_YEAR: "Please enter a valid Expiry Year",
    CVV: "Please enter a valid Cvv",
  },
});
